import {COUNTRIES, COUNTRY} from './env';

export const CURRENCIES_LIST = ['XAF', 'NGN'] as const;
export type CURRENCIES = typeof CURRENCIES_LIST[number];

export const CURRENCY_MAP: Partial<Record<COUNTRIES, CURRENCIES>> = {
    CAR: 'XAF',
    NG: 'NGN',
};

export const CURRENCY = CURRENCY_MAP[COUNTRY] ?? '—';
